import { render } from "./IncomeSummary.vue?vue&type=template&id=24e1214a&scoped=true"
import script from "./IncomeSummary.vue?vue&type=script&lang=js"
export * from "./IncomeSummary.vue?vue&type=script&lang=js"

import "./IncomeSummary.vue?vue&type=style&index=0&id=24e1214a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e1214a"]])

export default __exports__